// Removed import messages as close button is no longer needed

interface CreationFlowHeaderProps {
  title: string;
  onBack: () => void;
}

export function CreationFlowHeader({ title, onBack }: CreationFlowHeaderProps) {
  return (
    <div
      className="header-area fixed left-0 right-0 z-50 px-2 py-1 border-b border-divider bg-theme-bg"
      style={{
        top: 'env(safe-area-inset-top)',
        paddingTop: 'env(safe-area-inset-top)'
      }}
    >
      <button className="header-back-button" onClick={onBack}>
        <span className="material-symbols-outlined">arrow_back</span>
      </button>
      <span className="header-type text-base">{title}</span>
    </div>
  );
} 